export const ROUTES = {
  LOGIN: '/',
  SSO: '/sso-login',
  TWO_FACTOR: '/two-factor',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  MAINTENANCE: '/maintenance',
} as const;

const VIDA_WEB_URL = process.env.EXPO_PUBLIC_VIDA_WEB_URL || 'https://staging.vida.com';

export const EXTERNAL_URLS = {
  POST_LOGIN: `${VIDA_WEB_URL}/clients/`,
  ONBOARDING: `${VIDA_WEB_URL}/clients/onboarding/`,
  SUPPORT: process.env.EXPO_PUBLIC_SUPPORT_URL || 'https://support.vida.com',
  SUPPORT_EMAIL: `mailto:${process.env.EXPO_PUBLIC_SUPPORT_EMAIL || 'support@vida.com'}`,
} as const;

export const VALIDATION_LIMITS = {
  EMAIL_MAX_LENGTH: 254,
  PASSWORD_MIN_LENGTH: 1,
  CODE_MIN_LENGTH: 5,
  ORG_NAME_MAX_LENGTH: 254,
} as const;

export const ERROR_MESSAGES = {
  INVALID_CREDENTIALS: 'Please enter a correct email and password. Note that both fields may be case-sensitive.',
  INVALID_2FA_CODE: 'The code you have entered failed. Please try again.',
  SSO_NOT_SUPPORTED: "Sorry, SSO isn't yet supported for your organization. Click 'Back' to login or 'Sign up now' using the link below.",
  ENTER_ORG_NAME: "Please, enter your organization's name.",
  CHOOSE_ORG_FROM_LIST: 'Please, choose your organization from the list.',
  PASSWORD_RESET_SUCCESS: 'Successfully sent password reset email',
  PASSWORD_RESET_FAILED: 'Failed to send password reset email',
  EMAIL_LOGIN_LINK_SUCCESS: 'Login link has been sent to your email',
  EMAIL_LOGIN_LINK_FAILED: 'Failed to send login link. Please try again',
} as const;
